/* eslint-disable jsx-a11y/label-has-associated-control */
import type { InputHTMLAttributes } from 'react';
import React, { forwardRef } from 'react';
import type { BodySizeKeys } from '@noths/polaris-client-ribbons-base';
import { theme } from '@noths/polaris-client-ribbons-base';

import { Checkbox } from '../Checkbox/Checkbox';
import * as styles from './CheckboxWithLabel.styles';
import { fieldFeedbackContainer } from 'client-ribbons-design-system/components/elements/FieldWrapper/FieldWrapper.styles';
import { Feedback } from 'client-ribbons-design-system/components/elements/Feedback/Feedback';

export interface CheckboxWithLabelProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  error?: string | null;
  label: string;
  textSize?: BodySizeKeys;
}

const DEFAULT_TEXT_SIZE = 'MD';

export const CheckboxWithLabel = forwardRef<HTMLLabelElement, CheckboxWithLabelProps>(
  ({ className, error, label, textSize = DEFAULT_TEXT_SIZE, ...props }, forwardedRef) => {
    const errorId = error ? `${props.name || ''}-error` : undefined;

    return (
      <>
        <label
          className={className}
          css={[styles.checkboxLabel, props.disabled && styles.checkboxLabelDisabled]}
          ref={forwardedRef}
        >
          <Checkbox {...props} aria-describedby={errorId} aria-invalid={!!error} />
          <span
            css={[styles.checkboxLabelText, theme.responsiveText.BODY[textSize]]}
            dangerouslySetInnerHTML={{ __html: label }}
          />
        </label>
        {error && (
          <div css={[fieldFeedbackContainer, styles.checkboxErrorMessage]} role="alert">
            <Feedback error iconAlign="left" id={errorId} name={error} />
          </div>
        )}
      </>
    );
  },
);
